/**
 * File will hold application constants.
 */
 import Config from '@/config';
 import EnglishLangIcon from '@/assets/images/english@2x.png';
 import ChinaLangIcon from '@/assets/images/china@2x.png';
 import JapanLangIcon from '@/assets/images/japan@2x.png';
 
 export default {
   Theme: {
     Blue: '#285298',
     LightBlue: '#e3e9f2',
     AlertRed: '#f44436',
     Grey13: '#e0e0e0',
     Grey33: '#acacac',
     Grey47: '#898989',
     Grey75: '#414141',
     White: '#FFFFFF',
     Black: 'black',
     Green: '#28985C',
     Navy: '#43425D',
     Solitude: '#e9edf4'
   },
 
   SessionStorageKeys: {
     UserEmailAddress: 'UserEmailAddress',
     AccountConfirmed: 'ccAccountConfirmed',
     RegistrationSuccessful: 'ccSuccessfulRegistration',
     IsPublicParticipant: 'isPublicParticipant',
     SalesRepName: 'salesRepName',
     RegistrationFields: 'registrationFields',
     IsPresenter: 'isPresenter',
     IsListenOnly: 'isListenOnly',
   },
 
   Cookies: {
     LanguagePreference: "lang_pref",
   },
 
   get Api() {
     const Login = `${Config.SERVICE_API_URL}account/login`;
     const ResetPassword = `${Config.SERVICE_API_URL}account/{token}/changeForgottenPassword`;
     const ConferenceCallDetails = `${Config.SERVICE_API_URL}conferencecalls`;
     const UserRegistrationStatus = `${Config.SERVICE_API_URL}user/{emailAddress}/status?applicationId=6`;
     const RegisterNewUserUrl = `${Config.SERVICE_API_URL}user/register?applicationId=6`;
     const SaveTechSupport = `${Config.SERVICE_API_URL}nrs/mail/contact?applicationId=6`;
     const StatusAndProcessEntryCode = `${Config.SERVICE_API_URL}entrycode/statusAndProcessEntryCode`;
     const ShowPassword = `${Config.SERVICE_API_URL}showurl/{showLink}`;
     const Disclaimers = `${Config.SERVICE_API_URL}presentations/{presId}/disclaimers`;
     const Disclaimer = `${Config.SERVICE_API_URL}presentations/{presId}/disclaimerhtml/{disclaimerId}`;
     const UserPermission = `${Config.SERVICE_API_URL}account/getLoggedInUser?applicationId=6`;
     const Logout = `${Config.SERVICE_API_URL}account/logout`;
     const ConfirmUserEmail = `${Config.SERVICE_API_URL}user/{userRowGuid}/ConfirmEmail`;
     const DateTimeNowUrl = `${Config.SERVICE_API_URL}time`;
     const ConferenceCallStatusUrl = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{conferenceCallId}/status`;
     const AccessCodes = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/accesscode?replay={replay}`;
     const GetLoggedInUserForPresentation = `${Config.SERVICE_API_URL}account/GetLoggedInUserForPresentation`;
     const GetRegisteredUserForConferenceCall = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/participants`;
     const UpdateRegisteredUserForConferenceCall = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/participants/{ParticipantId}`;
     const RegisterForConferenceCall = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/participants`;
     const downloadIcsFile = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/icsfile`;
     const liveStreamUrl = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/livestream`;
     const replayAudioUrl = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/playback`;
     const participantSession = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/participantsessions`;
     const livestreamEvents = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/participantsessions/{ParticipantId}/events`;
     const UserInformation = `${Config.SERVICE_API_URL}user/{emailAddress}?applicationId=6&showLink={showLink}`;
     const Countries = `${Config.SERVICE_API_URL}countries?applicationId=3`;
     const ConferenceCallGlobalPhoneDirectory = `${Config.SERVICE_API_URL}conferencecallglobalphonedirectory`;
     const UserStatusUrl = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{conferenceCallId}/userstatus`;
     const GetSubmitQuestion = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{conferenceCallId}/questions`;
     const EditDeleteQuestion = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{conferenceCallId}/questions/{questionId}`;
     const SaveEntryCode = `${Config.SERVICE_API_URL}user/{email}/userpres`;
     const VerifyUserInformation =`${Config.SERVICE_API_URL}user/{emailAddress}/verifyInfo?appEnum=6`;
     const CompleteProfile = `${Config.SERVICE_API_URL}user/completeProfile?applicationId=6`;
     const resendVerificationEmail = `${Config.SERVICE_API_URL}presentations/{presId}/conferencecalls/{confId}/resendVerificationEmail?emailAddress={emailAddress}&showLink={showLink}&listenOnly={listenOnly}`;
     const resendSGMVerificationEmail = `${Config.SERVICE_API_URL}presentations/{presId}/smallgroupmeetings/{showLink}/resendVerificationEmail?emailAddress={emailAddress}`;
     const updateMetadata = `${Config.SERVICE_API_URL}user/{emailAddress}/metadata?showLink={showLink}`;
     const GetReleaseInfo = `${Config.API_GATEWAY_URL}eks/v1/info/releases`;
     const AccountTypes = `${Config.SERVICE_API_URL}accounttypes?activeOnly=true&applicationId=6`;
     const CompanyRoles = `${Config.SERVICE_API_URL}accounttypes/{accountTypeId}/companyroles`;
     const VerifyPresenterForLiveVideo = `${Config.SERVICE_API_URL}presentation/{presId}/verifyPresenter?emailAddress={emailAddress}`;
     const CompanySuggestions = `${Config.SERVICE_API_URL}user/{emailAddress}/companysuggestions`;
     const convertUtcToLocalTimezoneUrl = `${Config.SERVICE_API_URL}time/convertUTCToClientTimeZone?utcString={utcString}&ianaTimezone={ianaTimezone}&dateFormat={dateFormat}&utcDateFormat={utcDateFormat}`;
     const GetSGMDialInDetails = `${Config.SERVICE_API_URL}presentations/{presId}/smallgroupmeeting/{meetingId}/dialindetails`;
     const GetAttendeeUrl = `${Config.SERVICE_API_URL}presentation/{presId}/videowebinar/getConnectionUrl`;
     const GetMGMDialInDetails = `${Config.SERVICE_API_URL}presentations/{presId}/mgmevent/dialindetails`;
     const getSGMMeetingJoinLink = `${Config.SERVICE_API_URL}presentations/{presId}/smallgroupmeeting/{meetingId}/{showId}/managedzoommeetingjoinlink/{coreId}`;
     const getPresentationRouteUrl = `${Config.SERVICE_API_URL}/presentation/{presId}/route`;
     const ConfirmEmailDomain = `${Config.SERVICE_API_URL}user/{emailAddress}/confirmEmailDomain`;

     const getBrandingLogosUrl = `${Config.SERVICE_API_URL}presentation/eventBranding/{presId}/logo`;
     const getBrandingUrl = `${Config.BRANDING_SERVICE_API_URL}{brandingGuid}/stylesheet?appId={appId}`;
     const getBrandingInfoUrl = `${Config.BRANDING_SERVICE_API_URL}{brandingGuid}?FetchDeletedRegistrationFields=true&FetchDeletedCustomMessages=true`;
     
     const saveConsentToPolicyUrl = `${Config.API_GATEWAY_URL}access/session/privacypolicy`;
     const checkConsentToPolicyUrl = `${Config.API_GATEWAY_URL}access/session/privacypolicy/email/{email}`;
 
     return {
       Login,
       ResetPassword,
       ConferenceCallDetails,
       UserRegistrationStatus,
       RegisterNewUserUrl,
       SaveTechSupport,
       UserPermission,
       Logout,
       StatusAndProcessEntryCode,
       ShowPassword,
       Disclaimer,
       Disclaimers,
       AccessCodes,
       GetLoggedInUserForPresentation,
       GetRegisteredUserForConferenceCall,
       UpdateRegisteredUserForConferenceCall,
       RegisterForConferenceCall,
       DateTimeNowUrl,
       ConferenceCallStatusUrl,
       ConfirmUserEmail,
       downloadIcsFile,
       UserInformation,
       Countries,
       ConferenceCallGlobalPhoneDirectory,
       UserStatusUrl,
       GetSubmitQuestion,
       EditDeleteQuestion,
       liveStreamUrl,
       participantSession,
       livestreamEvents,
       SaveEntryCode,
       replayAudioUrl,
       VerifyUserInformation,
       CompleteProfile,
       resendVerificationEmail,
       resendSGMVerificationEmail,
       updateMetadata,
       GetReleaseInfo,
       AccountTypes,
       CompanyRoles,
       VerifyPresenterForLiveVideo,
       CompanySuggestions,
       convertUtcToLocalTimezoneUrl,
       GetSGMDialInDetails,
       GetAttendeeUrl,
       GetMGMDialInDetails,
       getSGMMeetingJoinLink,
       getPresentationRouteUrl,
       getBrandingUrl,
       getBrandingLogosUrl,
       getBrandingInfoUrl,
       saveConsentToPolicyUrl,
       checkConsentToPolicyUrl,
       ConfirmEmailDomain,
     };
   },
 
   ServiceMutationTypes: {
     Pending: 'pending',
     Success: 'success',
     FAILURE: 'failure'
   },
 
   Urls: {
     callManagementUrl: '/admin',
     presentationUrl: '/presentation/v2/{presId}/validate?l={logId}&show={showId}&confId={confId}',
     videoUrl: '/presentation/v2/{presId}/validate?l={logId}&show={showId}&confId={confId}',
   },
 
   UrlShowLink: 'show',
 
   RequiredFieldslabel: '* Required Field',
 
   DefaultDateFormat: 'DD/MM/YYYY',
   DefaultDateTimeFormat: 'DD/MM/YYYY [at] hh:mmA',
 
   UserLocaleShortDateFormat: 'LL',
   UserLocaleTimeFormat: 'LT',
   UserLocaleDateTimeFormat: 'LLLL',
   RegUserLocaleDateTimeFormat: 'dddd, D MMMM YYYY LT',
   TimezoneFormat:'dddd, d MMMM yyyy h:mm tt ZZ',
 
   ErrorMessages: {
     Required: 'error_messages.required',
     InvalidGuestCredentials: 'error_messages.invalid_guest_credentials',
     InvalidCredentials: 'error_messages.invalid_credentials',
     UnAuthorizedUser: 'error_messages.unauthorized_user',
     CaptchaRequired: 'error_messages.captcha_required',
     InvalidEmailDomain: 'error_messages.invalid_email_domain',
     PrivacyPolicyNotAccepted: 'error_messages.privacy_policy_not_accepted',
     StreamNotStartedTitle: 'error_messages.stream_not_started_title',
     StreamNotStartedMessage: 'error_messages.stream_not_started_message',
     ConnectionErrorTitle: 'error_messages.connection_error_title',
     ReconnectingErrorTitle: 'error_messages.reconnecting_error_title',
     AttemptingToConnectAgain: 'error_messages.attempting_to_connect_again',
     ConnectionLost: 'error_messages.connection_lost',
     AccessRevokedMessageForNoVideo: 'error_messages.access_revoked_message_for_no_video',
     AccessRevokedMessageForVideo: 'error_messages.access_revoked_message_for_video',
     GenericToasterErrorMessage: 'error_messages.generic_toaster_error_message',
     BrowserNotSupportedTitle: 'error_messages.browser_not_supported_title',
     BrowserNotSupported: 'error_messages.browser_not_supported',
     IOSNotSupported: 'error_messages.iOS_not_supported',
     PublicParticipantAccessRevokedMessage: 'error_messages.public_participant_access_revoked_message',
     PublicParticipantAccessRevokedMessageWithReplay: 'error_messages.public_participant_access_revoked_message_with_replay'
   },
 
   EmailValidation: {
     FirstTimeUserConfirmationPending: 'first_time_email_confirmation_pending_message',
   },
 
   EmailAddressRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
   PasswordRegex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
   PhoneNumberRegex: /^[\d\s()+-]*$/,
   ApplicationId: 6,
 
   Messages: {
     ConferenceCallDetailsFailure: 'messages.conference_call_details_failure',
     SupportRequestConfirmation: 'messages.support_request_confirmation',
     AccountConfirmation: 'messages.account_confirmation',
     RegistrationConfirmation: 'messages.registration_confirmation',
     EventNotAvailable: 'messages.event_not_available'
   },
 
   Translation: {
     FormOptionalSuffix: 'form.optional_suffix',
     SupplementFormFieldToolTip: 'form.{formfield}.tooltip',
     SupplementFormFieldLabel: 'form.{formfield}.label',
     JoinPreferenceOptionOnline: 'form.joinpreference.option.online',
     JoinPreferenceOptionPhone: 'form.joinpreference.option.phone',
     LoginInvitationString: 'login.invitation_string'
   },
 
   PageTitles: {
     AccountLogin: 'Administrator Login',
     AccountRegister: 'Create Administrator Account',
     TechSupport: 'Tech Support',
     GlobalNumbers: 'Global Dial-In Numbers',
     ResetPassword: 'Reset Password',
   },
   
   CapchtaSiteKey: '6Lco3AUTAAAAAIWu_cBONxTyoN04znwtKhLUDxJ1',
   TechnicalSupportNumber: '010-2222-2222',
 
   MaskedValue: '******',
   
   ConferenceStatus: 
   {
     Live: 'Live',
     Available: 'Available',
     Expired: 'Expired',
     StandBy: 'Standby',
     NotStarted: 'Not Started',
     Ended: 'Ended'
   },
   UserStatus: {
     NotConnected: 'Not Connected',
     Connected: 'Connected'
   },
   StreamingStates: {
     Published: 'Published',
   },  
   PollingTimeIntervals:{
     TimeApi: 1000,
     CallStatus: 45000,
     CallStatusSlowPoll: 60000,
     UserStatus: 45000,
     TextQuestions: 10000,
     ParticipantsApi: 60000,
     StillStreamingEvent: 30000
   },
 
   ConferenceCallStringStatus:{
     TimeLeftString: 'conference_call_string_status.time_left_string',
     LiveStreamingUnavailableUserNotConnected:'conference_call_string_status.live_streaming_unavailable_user_not_connected',
     Expired:'conference_call_string_status.expired',
     TimeLeftWithInTenMinutes: 'conference_call_string_status.time_left_with_in_ten_minutes',
     LiveStreamingAvailableUserNotConnected:'conference_call_string_status.live_streaming_available_user_not_connected',
     CallEndedReplayNotReady: 'conference_call_string_status.call_ended_replay_not_ready',
     CallEndedReplayReady: 'conference_call_string_status.call_ended_replay_ready',
     AvailableWithStreaming: 'conference_call_string_status.available_with_streaming',
     StandBy: 'conference_call_string_status.stand_by',
     LiveUserConnected: 'conference_call_string_status.live_user_connected',
     AvailableWithoutStreaming: 'conference_call_string_status.available_without_streaming', 
     ParticipantAccessRevoked: 'call_confirmation.access_revoked_msg',
   },
   ConferenceCallIcsFileName: 'Call Calendar Entry.ics',
 
   ConferenceCallEndedMessage: 'conference_call_ended.conference_call_ended_message',
   ConferenceReplayCallEnded: 'conference_call_ended.conference_replay_call_ended',
   WebinarEndedMessage: 'video_webinar_ended.event_ended_message',
   WebinarEndedReplayMessage: 'video_webinar_ended.event_ended_replay_message',
   QuestionErrorMsg: {
     ErrorEditingQuestion: "question_error_msg.error_editing_question",
     DeletingTextQuestionErrorMessage: "question_error_msg.deleting_text_question_error_message"
   },
   AskQuestionModalHeading: {
     onDialInMessage: 'ask_question_modal.on_dial_in_message',
     onStreamMessage:'ask_question_modal.on_stream_message'
   },
   RegisterPageHeading : {
     onMissingInformation: 'missing_info_title',
     onNewUserRegistration: 'new_reg_title'
   },
   ShowTypes: {
     confCallOnly: 'Conference Call Only',
     confCallAndSlides: 'Conference Call + Slides',
     liveVideoSlides: 'Live Video + Slides',
     SimuLive: 'Simu Live',
     videoWebinar: 'Video Webinar',
     simuLiveConferenceCallOnly: 'Simu-Live Conference Call Only',
     simuLiveConferenceCallAndSlide: 'Simu-Live Conference Call + Slides'
   },
   CacheKeysPrefix: {
     UserConferenceStatus: "UserConferenceStatus",
     ConferenceStatus: "ConferenceStatus",
     ParticipantData: "ParticipantData",
     QuestionsQueue: "QuestionsQueue"
   },
   MaintenanceBannerCookie: "conferencing_maintenance_banner_closed",
   BridgeTypes: {
     Compunetix: 'Compunetix',
     Lindenbaum: 'Lindenbaum'
   },
   EventIdTypes: {
     Automated: "Automated",
     OperatorAssisted: "OperatorAssisted",
     Replay: "Replay",
   },
   BrowserBannerCookie: "'nrs_browser_banner_closed'",
   Languages: {
     English: 'en-us',
     Chinese: 'zh-cn',
     Japanese: 'ja',
   },
   SupportedLanguages: [
     {
       Label: 'English',
       img: EnglishLangIcon,
       Value: 'en-us'
     },
     {
       Label: '中文',
       img: ChinaLangIcon,
       Value: 'zh-cn'
     },
     {
       Label: '日本語',
       img: JapanLangIcon,
       Value: 'ja'
     },
   ],
   QuestionTypes: {
     Text: "Text",
     Audio: "Audio"
   },
   ReplayTypes: {
     None: 'None',
     WebOnly: 'WebOnly',
     PhoneOnly: 'PhoneOnly',
     WebAndPhone: 'WebAndPhone',
     NrsLiveAudioOnly: 'NrsLiveAudioOnly',
     NrsLiveVideoAndSlides: 'NrsLiveVideoAndSlides',
     NrsLiveProduced: 'NrsLiveProduced'
  },
  BrandingLogoTypes: {
    Issuer: 1,
    Registration: 2
  },
  VideoWebinarPriorJoinTime:{
    Minutes: 120,
  },
  ParticipantRoleType: {
    Speaker: "Speaker",
    Participant: "Participant"
  },
  RegistrationTypes: {
    Standard: "Standard",
    ListenOnly: "ListenOnly"
  },
  
  lindenbaumExcludedCountryCodes: ['AOL'], // AOL and future country codes that need special formatting
}

  
   
 